export default "__VITE_ASSET__DbQhpgN7__"